<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div class="box box-info">
      <form>
        <!-- <Dropdown v-model="account" :options="supplierAndCustomerList"
            optionLabel="name"
            class="dropDown"
            :filter="true"
            placeholder="Select Party">
        </Dropdown> -->
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-3">
            <label>Party Account</label>
            <AutoComplete v-model="account" filterMatchMode='contains' :suggestions="filteredPartyAccount"
                          @complete="searchPartyAccount($event)" :dropdown="true" field="name"/>
          </div>
          <div class="p-field p-col-12 p-md-2">
            <label for="fromDate">From Date</label>
            <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
            <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate"/>
          </div>
          <div class="p-field p-col-12 p-md-2">
            <label for="toDate">To Date</label>
            <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
            <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate"/>
          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button @click.prevent="searchPartyStatement"
            class="p-button p-component addNewBtn btn-btm-0" icon="pi pi-search" label="Search"/>
          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button v-if="this.partyReportList.length > 0" @click.prevent="reset"
                    class="p-button-raised p-button-warning" label="Reset" icon="pi pi-refresh"/>
          </div>
 <div class="p-field p-col-12 p-md-1 p-mt-4">
          <!-- DataTable for PartyStatement -->
          <a href="#" @click.prevent="exportCSV()" class="p-field p-col-12 p-md-12"
             v-if="this.partyReportList.length > 0">
            <img src="../../../../static/img/excel.png" style="float:right;height: 3em;width: 3em;"/>
          </a>
 </div>

 <div class="p-field p-col-12 p-md-1 p-mt-4">
            <a href="#" @click.prevent="exportPDF()" v-if="this.partyReportList.length > 0">
              <img src="../../../../static/img/pdf.png" style="float: right;height: 3em;width: 3em;"/>
            </a>
          </div>

        </div>
      </form>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-col-12">
          <DataTable :value="partyReportList"
                     :paginator="true" ref="po"
                     :rows="100" :filters="filters"
                     :rowsPerPageOptions="[100,500,1000]"
                     class="p-datatable-responsive p-datatable-gridlines"
                     data-key="id">
            <template #empty>No record found</template>
            <Column header="S.N">
              <template #body="sl">
                {{ sl.index + 1 }}
              </template>
            </Column>
            <Column :sortable="true" header="Miti" field="transactionDateNepali" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['transactionDateNepali']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Date" field="transactionDate" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['transactionDate']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Vou Type" field="moduleType" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['moduleType']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Voucher" field="voucher" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['voucher']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Particulars" field="accountName" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['accountName']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Debit"
                    field="debitBalance" bodyStyle="color:#00a65a;text-align: right" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['debitBalance']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Credit" field="creditBalance"
                    filterMatchMode="contains" bodyStyle="color:#dd4b39;text-align: right">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['creditBalance']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Balance" bodyStyle="text-align: right" field="closingBalance"
                    filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['closingBalance']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Dr-CR" bodyStyle="text-align: right" field="drCr"
                    filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['drCr']"/>
              </template>
            </Column>
            <Column header="Action">
              <template #body="slotProps">
                <Button v-if="slotProps.data.tranModuleType == 'PIV'"
                        class="p-button-raised p-button-warning"
                        @click="exportToPurchasePdf(slotProps.data.refrenceId)" icon="pi pi-print"/>
                <Button v-if="slotProps.data.tranModuleType == 'SIV'"
                        class="p-button-raised p-button-warning"
                        @click="exportToSalesPdf(slotProps.data.refrenceId)" icon="pi pi-print"/>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import $ from 'jquery'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import InputText from 'primevue/inputtext'
import AutoComplete from 'primevue/autocomplete'
import InputMask from 'primevue/inputmask'
import Button from 'primevue/button'

export default {
  data() {
    return {
      loading: false,
      fromDate: null,
      toDate: null,
      partyReportList: [],
      supplierAndCustomerList: [],
      account: '',
      accountMasterId: null,
      englishDateEnabled: true,
      columnList: '',
      filters: {},
      selectedCountries: [],
      countries: null,
      filteredPartyAccount: null
    }
  },
  mounted() {
    this.supplierAndCustomer()
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.columnNames()
  },
  methods: {
    async supplierAndCustomer() {
      let response = await this.$store.dispatch('loadsupplierAndCustomerList')
      this.supplierAndCustomerList = response.data.data
    },
    async searchPartyStatement() {
      if (this.account === '') {
        this.accountMasterId = 0
      } else {
        this.accountMasterId = this.account.id
      }
      let partyStatementObject = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        accountId: this.accountMasterId
      }
      if (this.account === '') {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Please select at least one party!!', life: 10000})
        return
      }
      this.loading = true
      let response = await this.$store.dispatch('loadPartyStatement', partyStatementObject)
      this.loading = false
      this.partyReportList = response.data.data
      if (response.data.status === 'ERROR') {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      } else if (response.data.data.length > 0) {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
      }
    },
    exportPDF() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        accountMasterId: this.accountMasterId
      }
      axios({
        url: globalKey + '/fileDownload/printLedger/' + data.accountMasterId + '/accountLedger' + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + this.$store.getters.fyId + '/' + data.fromDate + '/' + data.toDate,
        method: 'get',
        headers: {'Accept': 'application/pdf', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'partyStatement.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    exportToPurchasePdf(SOHeaderId) {
      axios({
        url: globalKey + '/fileDownload/printPurchaseBill/' + SOHeaderId + '/purchaseInvoice' + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId,
        method: 'get',
        headers: {'Accept': 'application/pdf', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = 'purchaseInvoice.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    exportToSalesPdf(SOHeaderId) {
      axios({
        url: globalKey + '/fileDownload/printSalesBill/' + SOHeaderId + '/salesInvoice' + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId,
        method: 'get',
        headers: {'Accept': 'application/pdf', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = 'salesInvoice.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    exportCSV() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        columnList: this.columnList,
        accountMasterId: this.accountMasterId
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccounting/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/partyStatement' + '/' + this.$store.getters.fyId + '/' + data.columnList + '/' + data.accountMasterId + '/partyStatement',
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'partyStatement.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    reset() {
      this.partyReportList = []
      this.account = ''
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.fromDate = this.$store.getters.startDate
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.startDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    },
    searchPartyAccount(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredPartyAccount = [...this.supplierAndCustomerList]
        } else {
          this.filteredPartyAccount = this.supplierAndCustomerList.filter((account) => {
            return account.name.toLowerCase().startsWith(event.query.toLowerCase())
          })
        }
      }, 250)
    }
  },
  components: {
    Dropdown,
    DatePicker,
    DataTable,
    Column,
    InputText,
    AutoComplete,
    InputMask,
    Button
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">
</style>



// WEBPACK FOOTER //
// partyStatement.vue?29937c0e